document.addEventListener('DOMContentLoaded', () => {
  const shopMap = {
    teamstore: 'teamStoreContainer',
    fanshop: 'fanShopContainer',
    lpshop: 'lpShopContainer'
  };

  const shopItems = document.querySelectorAll('.cShopItem');
  const shopContainers = document.querySelectorAll('.shopContainer');

  if (window.__shopTabsInitialized) return;
  window.__shopTabsInitialized = true;

  shopItems.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const targetId = shopMap[item.id];

      shopItems.forEach(i => i.classList.remove('active'));
      shopContainers.forEach(c => {
        c.hidden = true;
        c.classList.remove('active');
      });

      item.classList.add('active');

      const target = document.getElementById(targetId);
      if (target) {
        target.hidden = false;
        target.classList.add('active');

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
